import { Column } from '@tanstack/react-table';

export function getDisplayNameFromColumn<TData>(
  column: Column<TData, unknown>
) {
  const { name: alternativeName } = (column.columnDef.meta ?? {}) as {
    name?: string;
  };
  return typeof column.columnDef.header === 'string'
    ? column.columnDef.header
    : alternativeName ?? column.id;
}
